/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Col_TypeInputs */

const en_directory_external_directories_col_type = /** @type {(inputs: Directory_External_Directories_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const zh_directory_external_directories_col_type = /** @type {(inputs: Directory_External_Directories_Col_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Directory_External_Directories_Col_TypeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_col_type = /** @type {((inputs?: Directory_External_Directories_Col_TypeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Col_TypeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_col_type(inputs)
	return zh_directory_external_directories_col_type(inputs)
});
export { directory_external_directories_col_type as "directory.external_directories.col_type" }